import { createFileRoute } from '@tanstack/react-router'

import { CustomPricingPage } from '@/features/cards/custom-pricing-page'

export const Route = createFileRoute('/_app/custom-pricing')({
    component: CustomPricingPage,
    staticData: { crumb: 'Custom pricing' }
})
